export const loginTabs = {
  LOGIN: 'Login',
  REGISTER: 'Register',
};
